import {
    ContentPlaceholder,
    Label,
    type ContentPlaceholderProps,
  } from './content-placeholder'
  
  export const Navbar = (props: ContentPlaceholderProps) => {
    return (
      <ContentPlaceholder minH="16" {...props}>
        <Label>Navbar</Label>
      </ContentPlaceholder>
    )
  }
  